var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0742 17.0742C13.1724 20.9753 6.82694 20.9753 2.92511 17.0742C-0.975037 13.1731 -0.975037 6.82584 2.92511 2.92475C4.87603 0.974619 7.43805 0 10.0001 0C12.5622 0 15.1233 0.974657 17.0742 2.92475C20.9753 6.8258 20.9753 13.1731 17.0742 17.0742ZM14.1262 7.05177C14.4522 6.72579 14.4522 6.19886 14.1262 5.87288C13.9636 5.7103 13.7502 5.62858 13.5367 5.62858C13.3233 5.62858 13.1098 5.7103 12.9473 5.87288L10.0001 8.821L7.05369 5.87374C6.89029 5.71116 6.67683 5.62944 6.46423 5.62944C6.25081 5.62944 6.03735 5.71116 5.87478 5.87374C5.5488 6.19972 5.5488 6.72747 5.87478 7.05263L8.82116 9.9999L5.87395 12.9472C5.54798 13.2731 5.54798 13.8009 5.87395 14.1261C6.19911 14.452 6.72685 14.452 7.05283 14.1261L10 11.1788L12.9472 14.1261C13.2732 14.452 13.8001 14.452 14.1261 14.1261C14.4521 13.8009 14.4521 13.2731 14.1261 12.9472L11.1789 9.9999L14.1262 7.05177Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/removeIcon.ce0210d4e236efc7896889bb06c783d1.svg";
export { ForwardRef as ReactComponent };